import {
  LocalOfferOutlined,
  PersonOutline,
  StoreOutlined,
} from "@mui/icons-material";
import ChevronRight from "@mui/icons-material/ChevronRight";
import {
  amber,
  brown,
  green,
  lightGreen,
  purple,
  red,
} from "@mui/material/colors";
import { isEmpty, size } from "lodash";
import { useMemo } from "react";
import Flx from "../../layout/Flx";
import ChipItem from "../../ui/ChipItem";

const CellRendererLoanName = (params) => {
  const loanNumber = useMemo(() => {
    return params?.data?.loanNumber;
  }, [params?.data?.loanNumber]);

  return (
    <Flx column g={0.8} sx={{ py: 2 }}>
      <Flx ac gap={0.4}>
        <span style={{ lineHeight: 1 }}>{params?.value || "asd"}</span>
        <ChevronRight color="inherit" sx={{ opacity: 0.4, fontSize: "16px" }} />
      </Flx>
      <Flx wrap gap={1}>
        {/* <ChipItem
          color={"#2962ff"}
          backgroundColor={lightBlue[50]}
          backgroundHoverColor={blue[100]}
          icon={<Tag className="thin-8" />}
          customContent={
            <Link
              color={"primary"}
              sx={{
                display: "flex",
                alignItems: "center",
                lineHeight: 1.8,
                fontSize: "11px",
                textDecoration: "none",
              }}
              href={`${window.location.origin}/loan/${loanNumber}`}
              target="_blank"
              rel="noreferrer"
            >
              {loanNumber}
              <OpenInNewRounded
                sx={{
                  display: "block",
                  fontSize: "11px !important",
                  marginLeft: 1,
                  color: "#2962ff",
                }}
              />
            </Link>
          }
          value={loanNumber}
        /> */}
        <LoanStatusChip loanStatus={params?.data?.loanStatus} />

        <ChipItem
          icon={<PersonOutline className="thin-8" />}
          value={`${size(params?.data?.borrowers)}`}
          // value={`Borrowers (${size(params?.data?.borrowers)})`}
        />
        <ChipItem
          icon={<StoreOutlined className="thin-8" />}
          value={`${size(params?.data?.subjectProperties)}`}
          // value={`Properties (${size(params?.data?.subjectProperties)})`}
        />
        <TagsRenderer tags={params?.data?.tags} />
      </Flx>
    </Flx>
  );
};

const TagsRenderer = ({ tags }) => {
  if (isEmpty(tags)) {
    return null;
  }
  return (
    <>
      {tags.map((tag) => (
        <ChipItem
          backgroundColor={purple[50]}
          color={purple[700]}
          icon={
            <LocalOfferOutlined
              sx={{ fontSize: "11px !important" }}
              className="thin-8"
            />
          }
          key={tag}
          value={tag}
        />
      ))}
    </>
  );
};

const LoanStatusChip = ({ loanStatus }) => {
  const styles = useMemo(() => {
    // let textColor = grey[900];
    // let textColor = blue[900];
    // let textColor = lightBlue[900];
    // let backgroundColor = lightBlue[50];
    // let backgroundHoverColor = blue[100];
    let textColor = green[900];
    let backgroundColor = lightGreen[50];
    let backgroundHoverColor = lightGreen[100];

    if (loanStatus === "Prospect") {
      textColor = brown[900];
      backgroundColor = amber[50];
      backgroundHoverColor = amber[100];
    }

    if (["Inactive", "Dead"].includes(loanStatus)) {
      textColor = red[900];
      backgroundColor = red[50];
      backgroundHoverColor = red[100];
    }
    if (
      [
        "Closed",
        "Closed w/ Post Closing Conditions",
        "Balance Sheet",
        "Loan Sold",
      ].includes(loanStatus)
    ) {
      textColor = lightGreen[50];
      backgroundColor = lightGreen[700];
    }

    return {
      color: textColor,
      backgroundColor: backgroundColor,
      backgroundHoverColor: backgroundHoverColor,
    };
  }, [loanStatus]);
  return (
    <ChipItem
      // color={"#2962ff"}
      color={styles.color}
      backgroundColor={styles.backgroundColor}
      // backgroundHoverColor={styles.backgroundHoverColor}
      // icon={<Tag className="thin-8" />}
      // sx={getRowStyle}
      value={loanStatus}
    />
  );
};

export default CellRendererLoanName;
